import { fromJS } from 'immutable';

import { VIEW_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import {
  ADD_NEW_MESSAGE,
  RESET_MESSAGES,
  RESET_NEW_MESSAGE,
} from '../../actions/Messages';

const initialState = fromJS({
  newMessage: {},
  isInitialLoaded: false,
});

export default function messages(state = initialState, action = {}) {
  switch (action.type) {
    case VIEW_GET_LOADED: {
      if (action.viewId === 'message') {
        return state.set('isInitialLoaded', true);
      }

      return state;
    }

    case ADD_NEW_MESSAGE: {
      return state.set('newMessage', fromJS(action.message));
    }

    case RESET_NEW_MESSAGE: {
      return state.set('newMessage', fromJS({}));
    }

    case RESET_MESSAGES: {
      return initialState;
    }

    default:
      return state;
  }
}
